import axios from 'axios';
import { getToken } from '../utils/auth';

// API Base URL from environment variable
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:1111';
const JSEARCH_API_KEY = process.env.REACT_APP_JSEARCH_API_KEY;
const JSEARCH_BASE_URL = "https://jsearch.p.rapidapi.com";
const WOOCOMMERCE_URL =
  process.env.REACT_APP_WOOCOMMERCE_URL ||
  "https://mapmypay.com/wp-json/wc/v3";

const WC_KEY = process.env.REACT_APP_WC_KEY;
const WC_SECRET = process.env.REACT_APP_WC_SECRET;
// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 seconds
});

// Request interceptor — attach the access token + session id on every request.
// This MUST live at module scope (not in the React hook): it becomes active the
// moment this module is imported, so even the earliest requests (e.g. a
// component's mount-time view-profile call, which fires before the App-level
// hook's useEffect registers) carry the token. Otherwise those early calls go
// out without x-access-token and 401.
// The RESPONSE interceptor (auto-refresh + logout) stays in the
// useAxiosInterceptor hook because it needs React Router's navigate.
apiClient.interceptors.request.use(
  (config) => {
    const sessionId = sessionStorage.getItem('sessionId');
    if (sessionId) {
      config.headers['x-session-id'] = sessionId;
    }

    const token = getToken();
    if (token) {
      config.headers['x-access-token'] = token;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default apiClient;


export const rapidApiClient = axios.create({
  baseURL: JSEARCH_BASE_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    "X-RapidAPI-Key": JSEARCH_API_KEY,
    "X-RapidAPI-Host": "jsearch.p.rapidapi.com",
  },
});

export const wooCommerceClient = axios.create({
  baseURL: WOOCOMMERCE_URL,
  timeout: 30000,
  auth: {
    username: WC_KEY,
    password: WC_SECRET,
  },
});